import { render, staticRenderFns } from "./WarehousingDetail.vue?vue&type=template&id=55a611da&scoped=true&"
import script from "./WarehousingDetail.vue?vue&type=script&lang=ts&"
export * from "./WarehousingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousingDetail.vue?vue&type=style&index=0&id=55a611da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a611da",
  null
  
)

export default component.exports